export const layouts = {
    'default': ["saldo1", "movim", "impostosPagos", "rendimentoBruto", "saldo2"],
    'mobile': ["saldo1", "saldo2", "movim", "impostosPagos", "rendimentoBruto"],
    'sem_imposto': ["saldo1", "movim", "rendimentoBruto", "saldo2"]
};
